import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { VULN_ISSUE_TYPE } from '../../../../../shared/issuesV2';
import { MalwareDisputeReasons } from '../../../../../shared/model-typings/malwaredisputes';
import { useCreateMalwareDispute } from '../../../../hooks/api/issues/useCreateMalwareDispute';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import { ModalReportMalwareDispute } from '../../../modals/ModalReportMalwareDispute';
import { useIssueDetailsModals } from '../IssueDetailsModalsContext';
import type { VulnIssue } from '../../../../../shared/issuesV2';

import styles from '../DisputeFooter.module.less';

/**
 * MalwareIssueDisputeFooter displays the "link" which the user can click to
 * report a malware detection as a false positive.
 */
export const MalwareIssueDisputeFooter: VoidFunctionComponent = () => {
  const issueDetails = useSelector(IssuesV2Store.selectors.getIssueDetails) as VulnIssue;
  const { malwareDisputeModal, isAnyModalOpen } = useIssueDetailsModals();
  const { mutateAsync, isPending, reset } = useCreateMalwareDispute();

  if (!issueDetails || issueDetails.type !== VULN_ISSUE_TYPE.Malware) {
    return null;
  }

  const onSubmit = async (comment: string) => {
    await mutateAsync({
      issueId: issueDetails.id,
      reason: MalwareDisputeReasons.FALSE_POSITIVE,
      comment,
    });
    malwareDisputeModal.onClose();
  };

  const onHide = () => {
    reset();
    malwareDisputeModal.onClose();
  };

  return (
    <>
      <footer className={styles.footer}>
        Found a mistake?
        {' '}
        <button
          type="button"
          className={styles.footerButton}
          onClick={() => !isAnyModalOpen && malwareDisputeModal.onOpen()}
          disabled={isAnyModalOpen}
        >
          Report a data issue with this malware report
        </button>
      </footer>
      <ModalReportMalwareDispute
        isPending={isPending}
        onHide={onHide}
        onSubmit={onSubmit}
        show={malwareDisputeModal.isOpen}
      />
    </>
  );
};
